import { StateCreator } from "zustand";
import validateStockBeforePayment from "../../utils/validateStockBeforePayment";
import type { TransaksiStore } from "../transaksiStore";

export interface ModalSlice {
    isOpenModalTransaksi: boolean;
    isOpenModalBayar: boolean;
    isOpenModalKonfirmasiBayar: boolean;
    checked: boolean;
    isKeterangan: boolean;
    openModalTransaksi: () => void;
    closeModalTransaksi: () => void;
    openModalBayar: () => void;
    closeModalBayar: () => void;
    openModalKonfirmasiBayar: () => void;
    closeModalKonfirmasiBayar: () => void;
    setChecked: (checked: boolean) => void;
    handleIsKeterangan: (checked: boolean) => void;
}

export const createModalSlice: StateCreator<
    TransaksiStore,
    [],
    [],
    ModalSlice
> = (set, get) => ({
    isOpenModalTransaksi: false,
    isOpenModalBayar: false,
    isOpenModalKonfirmasiBayar: false,
    checked: false,
    isKeterangan: false,
    openModalTransaksi: () => set({ isOpenModalTransaksi: true }),
    closeModalTransaksi: () => set({ isOpenModalTransaksi: false }),
    openModalBayar: () => {
        const { cart, resetBayar } = get();
        if (validateStockBeforePayment(cart)) {
            set({ isOpenModalBayar: true });
            resetBayar();
        }
    },
    closeModalBayar: () => set({ isOpenModalBayar: false }),
    openModalKonfirmasiBayar: () =>
        set({ isOpenModalKonfirmasiBayar: true, isOpenModalBayar: false }),
    closeModalKonfirmasiBayar: () =>
        set({ isOpenModalKonfirmasiBayar: false, isOpenModalBayar: true }),
    setChecked: (checked) => set({ checked }),
    handleIsKeterangan: (checked) => set({ isKeterangan: checked }),
});
